import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* technicianTagsFetchTagsListSaga(action) {

    yield put(actions.technicianTagsFetchTagsListStart());


    try {
        const response = yield axios.get(api.technicianTagsFetchTagsList);
        yield put(actions.technicianTagsFetchTagsListSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.technicianTagsFetchTagsListFail(error.response.data.error));
        }else {
            yield put(actions.technicianTagsFetchTagsListFail("There's an error!"));
        }
    }

}